"use strict";
/**
 * OpenSearch Material Search Types
 *
 * These types represent the structure of material documents in OpenSearch indices.
 * They match the output of filterPublicMaterialForIndex and filterPrivateMaterialForIndex
 * from lambda-utilities/src/utils/opensearch-document-filters.ts
 */
Object.defineProperty(exports, "__esModule", { value: true });
